const Logo = ({ width = 159, height = 32, className = "" }) => {
  // Calculate the scaling factor based on the original viewBox
  const viewBoxWidth = 159;
  const viewBoxHeight = 32;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M60.9559 27.8388L51.6853 4.97583H56.853L59.8284 12.4297L61.4569 17.065L63.0542 12.5863L66.0609 4.97583H71.2286L61.9581 27.8388H60.9559Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M86.2924 4.59985C101.702 4.59985 101.702 27.6821 86.2924 27.6821C70.8833 27.6821 70.8833 4.59985 86.2924 4.59985ZM86.2924 9.20368C77.3351 9.20368 77.3351 23.0468 86.2924 23.0468C95.2496 23.0468 95.2496 9.20368 86.2924 9.20368Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M108.09 4.97559V22.8901H115.199V27.3688H103.611V4.97559H108.09Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M130.984 9.20364C122.12 9.20364 122.12 22.8588 130.984 22.8588C132.926 22.8588 134.46 22.2951 135.306 21.8567L135.901 26.492C134.523 27.0557 132.55 27.4315 130.984 27.4315C115.794 27.4315 115.825 4.6936 130.984 4.6936C132.55 4.6936 134.053 4.97547 135.4 5.5705L134.867 10.1744C134.022 9.73606 132.925 9.20364 130.984 9.20364Z"
        fill="url(#paint3_linear)"
      />
      <path
        d="M148.459 4.16138H148.929L158.356 27.3689H153.314L152.405 24.9574H144.983L144.105 27.3689H139.032L148.459 4.16138ZM150.745 20.7605L148.71 14.9352L146.611 20.7605H150.745Z"
        fill="url(#paint4_linear)"
      />
      <path
        d="M29.786 11.3839L21.8199 7.83544L40.4124 0L40.4379 7.40674L29.786 11.3839ZM40.5666 24.4548L29.8876 20.542L21.946 24.1451L40.592 31.8615L40.5666 24.4548ZM34.6495 16.3292L34.6469 15.5715L25.2895 11.4035L17.3234 7.85505L0 0.138569L0.0255241 7.54531L9.38203 11.4581L11.7359 12.4425L4.62013 15.6709L4.62273 16.4287L11.7694 19.612L9.41357 20.6162L0.0842294 24.5933L0.109739 32L17.3798 24.1646L25.3213 20.5615L34.6495 16.3292Z"
        fill="url(#paint5_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="70.1527"
          y1="29.3366"
          x2="46.2089"
          y2="13.2016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E51000" />
          <stop offset="1" stopColor="#FF7C38" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="96.5768"
          y1="29.1942"
          x2="71.2083"
          y2="9.16812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E51000" />
          <stop offset="1" stopColor="#FF7C38" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="114.561"
          y1="28.8357"
          x2="96.8624"
          y2="21.6155"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E51000" />
          <stop offset="1" stopColor="#FF7C38" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="135.004"
          y1="28.921"
          x2="112.996"
          y2="16.4853"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E51000" />
          <stop offset="1" stopColor="#FF7C38" />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1="157.292"
          y1="28.8893"
          x2="133.233"
          y2="13.0963"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E51000" />
          <stop offset="1" stopColor="#FF7C38" />
        </linearGradient>
        <linearGradient
          id="paint5_linear"
          x1="38.3573"
          y1="34.0963"
          x2="2.19976"
          y2="-2.0612"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E51000" />
          <stop offset="1" stopColor="#FF7C38" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;
